import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'CollectionPage',
};

import { computed, useContext, useRoute } from '@nuxtjs/composition-api';
import ExpandedCollectionPage from '~/components/collection/ExpandedCollectionPage.vue';
import BasicCollectionPage from '~/components/collection/BasicCollectionPage.vue';
import { ExperimentTypes } from '~/types/experiments';

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { $getExperiment } = useContext();

const experiment = $getExperiment(ExperimentTypes.EventLandingPages);
const payload = computed(() =>
  experiment?.payload && Array.isArray(experiment?.payload) ? experiment.payload : null
);
const $route = useRoute();
const shouldUseNewCollectionPage = computed(
  () => experiment?.value === 'on' && payload.value?.includes($route.value.path)
);

return { __sfc: true,$getExperiment, experiment, payload, $route, shouldUseNewCollectionPage, ExpandedCollectionPage, BasicCollectionPage }
}

})